
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/high-school/[id]/[sport]/[year]/schedule",
      function () {
        return require("private-next-pages/high-school/[id]/[sport]/[year]/schedule.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/high-school/[id]/[sport]/[year]/schedule"])
      });
    }
  